const HowToVideos = ({sections}) => {
    return (
        <div className={'preview-wrapper'}>
            {sections[0] ?
                <video
                    id="preview-video"
                    key={"previewCustomize"}
                    playsInline={true}
                    autoPlay={true}
                    muted={true}
                    preload={'auto'}
                    poster={require('../../../../../assets/about_preview1.webp')}
                    controlsList={'nodownload'}
                >
                    <source src={require('../../../../../assets/videos/Feedback_Customize.webm')} type="video/webm"/>
                    <source src={require('../../../../../assets/videos/Feedback_Customize.mp4')} type="video/mp4"/>
                </video> :
                sections[1] ?
                    <video
                        id="preview-video"
                        key={"previewTrigger"}
                        muted={true}
                        playsInline={true}
                        autoPlay={true}
                        preload={'auto'}
                        poster={require('../../../../../assets/about_preview2.webp')}
                        controlsList={'nodownload'}
                    >
                        <source src={require('../../../../../assets/videos/Feedback_Trigger.webm')} type="video/webm"/>
                        <source src={require('../../../../../assets/videos/Feedback_Trigger.mp4')} type="video/mp4"/>
                    </video> :
                    sections[2] ?
                        <video
                            id="preview-video"
                            key={"previewAnalyse"}
                            playsInline={true}
                            muted={true}
                            autoPlay={true}
                            preload={'auto'}
                            poster={require('../../../../../assets/about_preview3.webp')}
                            controlsList={'nodownload'}
                        >
                            <source src={require('../../../../../assets/videos/Feedback_Analyse.webm')}
                                    type="video/webm"/>
                            <source src={require('../../../../../assets/videos/Feedback_Analyse.mp4')}
                                    type="video/mp4"/>
                        </video>
                        : ''
            }
        </div>
    )
}

export default HowToVideos